export const SET_ENDORSEMENTS_ERROR = 'SET_ENDORSEMENTS_ERROR';
export const SET_ENDORSEMENTS_LIST = 'SET_ENDORSEMENTS_LIST';
export const SET_TOTAL_AMOUNT_OF_ENDORSEMENTS = 'SET_TOTAL_AMOUNT_OF_ENDORSEMENTS';
export const SET_FETCHING_ENDORSEMENTS = 'SET_FETCHING_ENDORSEMENTS';
export const SET_ENDORSEMENTS_SHOW_MODAL = 'SET_ENDORSEMENTS_SHOW_MODAL';
export const SET_ENDORSEMENTS_ADD_ERROR = 'SET_ENDORSEMENTS_ADD_ERROR';
export const SET_ENDORSEMENTS_ADD_SUCCESS = 'SET_ENDORSEMENTS_ADD_SUCCESS';
export const SET_ENDORSEMENTS_ADD_FETCHING = 'SET_ENDORSEMENTS_ADD_FETCHING';
